// extracted by mini-css-extract-plugin
export default {"button":"Jo-z","reviewSort":"Ko-z"};